import { Component, OnInit, Input, AfterViewInit, ChangeDetectorRef, OnDestroy, ChangeDetectionStrategy, SimpleChanges, OnChanges, ViewContainerRef, ViewChild, ElementRef } from '@angular/core';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { DialogConfig } from '../../../dialog/dialog-config';
import { AIService } from '../../services/ai.service';

declare var Chart: any;
declare var mermaid: any;

@Component({
    selector: 'app-kx-ai-output',
    templateUrl: './kx-ai-output.component.html',
    styleUrls: ['./kx-ai-output.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class KxAiOutputComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('customComponent', { read: ViewContainerRef }) customComponent!: ViewContainerRef;
  @ViewChild('langflowFrame') iframe!: ElementRef;
  //langflowSrc: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl('assets/langflow-chat.html');


  @Input() set config(value: any) {
    if (value) {
      this._config = value;
      this.initializeComponent(value);
    }
  }
  get config(): any {
    return this._config;
  }
  private _config: any = { defaultViewMode: false, loaded: false, noData: false, outputType: "html", errMsg: "",askData:false };
  
  analyticsData: {
    summary?: string | any;
    charts?: any[];
    timestamp?: string;
    tables?: Array<{
      title: string;
      columns: string[];
      rows: string[][];
    }>;
  } = {};
  chartInstances: any[] = [];
  chartViewModes: { [key: string]: 'chart' | 'table' } = {};
  renderedSummary: SafeHtml | string = '';
  isLoaded: boolean = false;
  private chartRegistry: { [key: string]: any } = {};

  constructor(
    public rolePermissionService: RolePermissionService,
    public baseService: BaseService,
    public alertService: AlertsService,
    public loader: LoaderService,
    public aiService: AIService,
    public dialogConfig: DialogConfig,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {    
    //this.langflowSrc = this.sanitizer.bypassSecurityTrustResourceUrl('assets/langflow-chat.html');

  }

  ngOnInit(): void {
    this.initializeComponent(this.config);
  }

  // updateLangflowConfig() {
  //   const payload = {
  //     final_url: btoa(this.dialogConfig.data.config.final_url),
  //     prompt_code: this.dialogConfig.data.aiData.gridConfig.prompt_config_current.prompt_code,
  //     feature: this.dialogConfig.data.aiData.gridConfig.prompt_config_current.ai_feature_code,
  //     templateName: this.dialogConfig.data.aiData.gridConfig.prompt_config_current.template_name
  //   };
  
  //   const hash = btoa(JSON.stringify(payload));
  //   this.langflowSrc = this.sanitizer.bypassSecurityTrustResourceUrl(`assets/langflow-chat.html#${hash}`);
  // }

  private initializeComponent(config: any): void {
    if (config) {
      console.log('Initializing with config:', config); // Debug log
      this.isLoaded = config.loaded;
      if(config.outputType == AIService.ASK_YOUR_DATA){
        
        //this.updateLangflowConfig();
        this.cdr.markForCheck();
      }else{
        this.analyticsData = config.summary;
      
        this.renderedSummary = this.parseSummary(config.summary);
        if(this.config?.selector != undefined){
          this.createComponent(this.config?.selector,this.config);
        }else{
          if (this.analyticsData?.charts) {
            console.log('Found charts:', this.analyticsData.charts); // Debug log
            this.analyticsData.charts.forEach(chart => {
              chart['cols'] = this.getTableColumns(chart);
              chart['chData'] = this.getTableData(chart);
              this.chartViewModes[chart.title] = config.defaultViewMode ? 'table' : 'chart';
            });
            setTimeout(() => {
              if (!config.defaultViewMode) {
                this.renderChartsWithRetry();
              }
            });
          }
        }
        this.cdr.markForCheck();
      }
      
     

      
    }
  }

  createComponent(kxselector: any, input?) {
    setTimeout(() => {
      this.customComponent?.clear();
      this.baseService.createComponent(kxselector, this.customComponent, (response) => {
        if (response) {
          response.setInput('data', input.summary);
          if (kxselector == 'app-kx-ai-patient-summary') {
            if (this?.dialogConfig?.data?.config?.selectedDatas) {
              response.setInput('selectedDatas', this.dialogConfig.data.config.selectedDatas);
            }
            
          }
        }
      })
    })
  }

  private isSafeHtml(value: any): value is SafeHtml {
    return value && typeof value === 'object' &&
           value.changingThisBreaksApplicationSecurity !== undefined;
  }

  private parseSummary(summary: any): SafeHtml | string {
    if (!summary) return '';
    
    if (this.isSafeHtml(summary)) {
      return summary;
    }
    const cleanHtml = (content: string): SafeHtml => {
      const cleaned = content
        ?.replace(/```html\s*/gi, '')
        ?.replace(/```\s*/g, '')
        ?.trim();
  
      return this.sanitizer.bypassSecurityTrustHtml(cleaned);
    };
    if (typeof summary === 'string') {
      return cleanHtml(summary);
    }
    
    if (typeof summary === 'object') {
      if (summary.text) {
        return cleanHtml(summary.text);
      }
      if (summary.content) {
        return cleanHtml(summary.content);
      }
      if (summary.html) {
        return cleanHtml(summary.html);
      }
      return JSON.stringify(summary, null, 2);
    }
    
    return String(summary);
  }

  get summaryPoints(): string[] {
    if (!this.analyticsData?.summary) return [];
    // Split summary by bullet points (•) or new lines
    if(Array.isArray(this.analyticsData.summary)){
      return this.analyticsData.summary;
    }else{
      return this.analyticsData.summary
      .split(/(•|\n)/)
      .filter(point => point.trim() && !['•', '\n'].includes(point))
      .map(point => point.trim());
    }
  }
  

  ngOnChanges(changes: SimpleChanges): void {
    console.log('Changes detected:', changes); // Debug log
    if (changes.config) {
      const newConfig = changes.config.currentValue;
      if (newConfig) {
        console.log('New config received:', newConfig); // Debug log
        this.initializeComponent(newConfig);
      }
    }
  }

  ngOnDestroy(): void {
    this.cleanupCharts();
  }

  private cleanupCharts(): void {
    // Destroy all registered charts
    Object.keys(this.chartRegistry).forEach(chartId => {
      const chart = this.chartRegistry[chartId];
      if (chart && typeof chart.destroy === 'function') {
        try {
          chart.destroy();
        } catch (error) {
          console.warn(`Error destroying chart ${chartId}:`, error);
        }
      }
      delete this.chartRegistry[chartId];
    });

    // Clear all canvas elements
    if (this.analyticsData?.charts) {
      this.analyticsData.charts.forEach(chartConfig => {
        const canvasId = this.getSafeChartId(chartConfig.title);
        const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
        if (canvas) {
          const ctx = canvas.getContext('2d');
          if (ctx) {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            // Reset canvas dimensions to force a complete refresh
            canvas.width = canvas.width;
            canvas.height = canvas.height;
          }
        }
      });
    }
  }

  toggleViewMode(chartTitle: string): void {
    const newMode = this.chartViewModes[chartTitle] === 'chart' ? 'table' : 'chart';
    this.chartViewModes[chartTitle] = newMode;
    
    if (newMode === 'chart') {
      setTimeout(() => {
        this.renderChartsWithRetry();
      });
    }
    
    this.cdr.markForCheck();
  }

  
  setDefaultViewMode(mode: 'chart' | 'table') {
    console.log('Setting view mode to:', mode);
    this.config.defaultViewMode = mode === 'table';
    
    if (!this.config.defaultViewMode) {
      setTimeout(() => {
        this.renderChartsWithRetry();
      }, 100);
    }
  }

  private renderChartsWithRetry(retryCount = 0): void {
    if (retryCount > 5) {
      console.warn('Max retry attempts reached for chart rendering');
      return;
    }

    if (this.analyticsData?.charts) {
      const allChartsReady = this.analyticsData.charts.every(chartConfig => {
        const canvasId = this.getSafeChartId(chartConfig.title);
        const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
        return canvas !== null;
      });

      if (allChartsReady) {
        // Ensure cleanup happens before rendering
        this.cleanupCharts();
        // Add a longer delay to ensure cleanup is complete
        setTimeout(() => {
          this.renderCharts();
        }, 100);
      } else {
        setTimeout(() => {
          this.renderChartsWithRetry(retryCount + 1);
        }, 200);
      }
    }
  }

  private renderCharts(): void {
    if (this.analyticsData?.charts) {
      this.analyticsData.charts.forEach(chartConfig => {
        const canvasId = this.getSafeChartId(chartConfig.title);
        const canvasElement = document.getElementById(canvasId) as HTMLCanvasElement;

        if (canvasElement) {
          try {
            // Ensure any existing chart is destroyed
            if (this.chartRegistry[canvasId]) {
              try {
                this.chartRegistry[canvasId].destroy();
              } catch (error) {
                console.warn(`Error destroying existing chart for ${canvasId}:`, error);
              }
              delete this.chartRegistry[canvasId];
            }

            const ctx = canvasElement.getContext('2d');
            if (ctx) {
              // Clear the canvas
              ctx.clearRect(0, 0, canvasElement.width, canvasElement.height);
              // Reset canvas dimensions
              canvasElement.width = canvasElement.width;
              canvasElement.height = canvasElement.height;
              
              // Ensure chart data is properly formatted
              const chartData = this.prepareChartData(chartConfig);
              
              // Create new chart instance
              const chart = new Chart(ctx, {
                type: chartData.type || 'bar',
                data: {
                  labels: chartData.data.labels,
                  datasets: chartData.data.datasets.map(dataset => ({
                    label: dataset.label,
                    data: dataset.data,
                    //backgroundColor: dataset.backgroundColor || this.getRandomColor(),
                    //borderColor: dataset.borderColor || this.getRandomColor(0.8),
                    borderWidth: 1
                  }))
                },
                options: {
                  responsive: true,
                  maintainAspectRatio: false,
                  animation: {
                    duration: 0 // Disable animations for better performance
                  },
                  plugins: {
                    legend: {
                      position: 'top',
                    },
                    colorschemes: {
                      scheme: 'brewer.Dark2' // or any of the supported names
                    },
                    ...chartData.options?.plugins
                  }
                }
              });

              // Store the chart instance in registry
              this.chartRegistry[canvasId] = chart;
            }
          } catch (error) {
            console.error(`Error creating chart for ${chartConfig.title}:`, error);
          }
        }
      });
      this.cdr.markForCheck();
    }
  }

  private getRandomColor(alpha: number = 0.6): string {
    const r = Math.floor(Math.random() * 255);
    const g = Math.floor(Math.random() * 255);
    const b = Math.floor(Math.random() * 255);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  private prepareChartData(chartConfig: any): any {
    // If chartConfig is a string, try to parse it
    if (typeof chartConfig === 'string') {
      try {
        chartConfig = JSON.parse(chartConfig);
      } catch (e) {
        console.error('Failed to parse chart config:', e);
        return chartConfig;
      }
    }

    // Ensure data is properly formatted
    if (!chartConfig.data) {
      console.error('Chart config missing data:', chartConfig);
      return chartConfig;
    }

    // If data is a string, try to parse it
    if (typeof chartConfig.data === 'string') {
      try {
        chartConfig.data = JSON.parse(chartConfig.data);
      } catch (e) {
        console.error('Failed to parse chart data:', e);
      }
    }

    // Ensure datasets are properly formatted
    if (chartConfig.data.datasets) {
      chartConfig.data.datasets = chartConfig.data.datasets.map((dataset: any) => {
        if (typeof dataset === 'string') {
          try {
            return JSON.parse(dataset);
          } catch (e) {
            console.error('Failed to parse dataset:', e);
            return dataset;
          }
        }
        return dataset;
      });
    }

    console.log('Prepared chart data:', chartConfig); // Debug log
    return chartConfig;
  }

  getTableData(chartData: any): any[] {
    if (!chartData?.data?.labels || !chartData?.data?.datasets) return [];
    
    return chartData.data.labels.map((label: string, index: number) => {
      const row: any = { 'Label': label };
      chartData.data.datasets.forEach((dataset: any) => {
        if (dataset.data?.[index] !== undefined) {
          row[dataset.label || 'Value'] = dataset.data[index];
        }
      });
      return row;
    });
  }

  getTableColumns(chartData: any): string[] {
    if (!chartData?.data?.datasets) return ['Label'];
    return ['Label', ...chartData.data.datasets.map((dataset: any) => dataset.label?.toString() || 'Value')];
  }

  getSafeChartId(title: string): string {
    return title.toLowerCase().replace(/\s+/g, '-') + '-chart';
  }

  private fixEncoding(str: string): string {
    try {
      if (/[^\\x00-\\x7F]/.test(str)) {
        return decodeURIComponent(escape(str));
      }
      return str;
    } catch (err) {
      console.warn("Encoding fix failed:", err);
      return str;
    }
  }

  private getCompositeValue(field: any, row: any): string {
    if (!field.format) return row[field.name];
    
    try {
      const formatFn = new Function('item', field.format.replace('fn=', ''));
      return formatFn(row);
    } catch (error) {
      console.error('Error executing composite format:', error);
      return row[field.name];
    }
  }
}